import styles from "../styles/filter-card.module.scss";
import { CardFilter, Filter } from "@/data/filters.constants";
import Image from "next/image";
import useHover from "@/hooks/use-hover";

interface FilterCardProps {
  filter: CardFilter;
  onSelectFilter: (filter: Filter) => void;
  selectedFilter: Filter;
}

const FilterCard = ({
  filter,
  onSelectFilter,
  selectedFilter,
}: FilterCardProps) => {
  // need to use inline style because title has absolute position
  const { isHovering, onMouseEnter, onMouseLeave } = useHover();
  return (
    <div className={styles.background_wrapper}>
      <div
        className={`${styles.card} ${selectedFilter.category === filter.category && styles.selected} ${isHovering && styles.selected}`}
        style={{ background: filter.background }}
        onClick={() => onSelectFilter(filter)}
      >
        <Image src={filter.image} alt={filter.title} width={108} height={108} />
      </div>
      <div
        className={styles.title}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {filter.title}
      </div>
    </div>
  );
};

export default FilterCard;
